module.exports = __webpack_public_path__ + "Banner_PRODUCTS.jpg?e7287549c9ad24f39bba1822b47e43ee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/Banner_PRODUCTS.jpg
// module id = 197
// module chunks = 0